module.exports = __webpack_public_path__ + "static/media/5-10.a2b76627.png";